export default "__VITE_ASSET__CSIGSk6y__"